import { render, staticRenderFns } from "./MobileDetails.vue?vue&type=template&id=79e8bf08&"
import script from "./MobileDetails.vue?vue&type=script&lang=js&"
export * from "./MobileDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e8bf08')) {
      api.createRecord('79e8bf08', component.options)
    } else {
      api.reload('79e8bf08', component.options)
    }
    module.hot.accept("./MobileDetails.vue?vue&type=template&id=79e8bf08&", function () {
      api.rerender('79e8bf08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/mobiledetails/MobileDetails.vue"
export default component.exports